import { AxiosError } from "axios";
import { useSetAtom } from "jotai";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { Intent, IntentSentence, IntentSentenceUpdateAnswer } from "@/model";
import sentenceRepository from "@/repository/sentenceRepository";
import { intentQueryKeys } from "@/query/intent";
import { intentTableRefetchAtom } from "@/atom/intentTable";


export const useUpdateIntentSentenceAnswer = (
    agentId: number, skillId?: number, intentId?: string, sentenceKey?: string
) => {
    const queryClient = useQueryClient();
    const setIntentTableRefetch = useSetAtom(intentTableRefetchAtom);

    return useMutation<IntentSentence[], AxiosError, IntentSentenceUpdateAnswer>({
        mutationKey: ["intent-sentence", "agent", agentId, "skill", skillId, "intent", intentId, "sentenceKey", sentenceKey, "update", "answers"],
        mutationFn: async (body: IntentSentenceUpdateAnswer) => {
            try {
                const { data } = await sentenceRepository.updateAnswers(agentId, skillId!, intentId!, sentenceKey!, body);
                return data.data;
            } catch (e) {
                throw e;
            }
        },
        onSuccess: async (newIntentSentences) => {
            const intents = await queryClient.getQueryData(intentQueryKeys.intents(agentId, skillId)) as Intent[];
            const newIntentSentence = newIntentSentences.find(sentence => sentence.key === sentenceKey);
            if (!newIntentSentence) {
                return;
            }

            intents.forEach(intent => {
                if (intent.id === intentId) {
                    intent.sentences = intent.sentences.map(sentence => sentence.key === sentenceKey ? newIntentSentence : sentence);
                }
            });
            setIntentTableRefetch(true);
        }
    });
};
